$(function(){
    $('.stuff_slider').on('init', function(event, slick){
        set_stuff_slider_progress(slick);
        var pid = slick.$slider.data('pid');
        var controls = $('.stuff_slider_controls[data-pid="'+pid+'"]');

        controls.find('.arrow_prev').on('click', function(){
            slick.slickPrev();
        });
        controls.find('.arrow_next').on('click', function(){
            slick.slickNext();
        });
    }).slick({
        arrows: false, 
        infinite: false, 
        slidesToShow: 3, 
        responsive: [
            {
                breakpoint: 1100, 
                settings: {
                    slidesToShow: 2
                }
            }, 
            {
                breakpoint: 767, 
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    }).on('beforeChange', function(event, slick, cur_index, next_index){
        var left = Math.ceil(next_index/slick.slideCount*100);
        var pid = slick.$slider.data('pid');

        var controls = $('.stuff_slider_controls[data-pid="'+pid+'"]');
        controls.find('.progress_bar div').css({
            'left': left+'%'
        });
    }).on('breakpoint', function(event, slick){
        set_stuff_slider_progress(slick);
    });
});

function set_stuff_slider_progress(slick){
    var to_show = slick.slickGetOption('slidesToShow');
    var width = Math.ceil(to_show/slick.slideCount*100);
    var left = Math.ceil(slick.currentSlide/slick.slideCount*100);
    var pid = slick.$slider.data('pid');

    var controls = $('.stuff_slider_controls[data-pid="'+pid+'"]');
    controls.find('.progress_bar div').css({
        'width': width+'%', 
        'left': left+'%'
    });
}